/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: weekday-selector-component.js
 *
 * Created by randysorensen on 3/27/17.
 */

'use strict';

function WeekdaySelectorController ($scope, $attrs, UtilsService) {
	var self = this;

	self.disabled = $scope.$eval($attrs.ngDisabled);

	//======//
	// Grid //
	//======//

	self.colDefs = [];
	var createWeekdayColDef = function (dayOfWeek) {
		return {
			name: dayOfWeek + 'Column',
			field: dayOfWeek,
			width: 75,
			enableColumnResizing: false,
			headerCellTemplate: '<div class="text-align-center">' + dayOfWeek + '</div>',
			cellTemplate: 'components/visual/weekdaySelector/gridTemplates/weekday-grid-cell-template.html'
		};
	};

	angular.forEach(UtilsService.constants.WEEKDAYS, function (dayOfWeek) {
		self.colDefs.push(createWeekdayColDef(dayOfWeek));
	});

	self.gridOptions = {
		enableRowHeaderSelection: false,
		enableColumnResizing: false,
		rowHeight: 28,
		minRowsToShow: 1,
		enableScrollbars: false,
		columnDefs: self.colDefs,
		data: [{}]
	};


	//================//
	// Event Handlers //
	//================//

	self.toggleDayOfWeek = function (dayOfWeek, event) {
		event.preventDefault();
		event.stopImmediatePropagation();

		if (self.enabledDays.indexOf(dayOfWeek) >= 0) {
			var idx = self.enabledDays.indexOf(dayOfWeek);
			self.enabledDays.splice(idx, 1);
		} else {
			self.enabledDays.push(dayOfWeek);
		}
		self.updated();
	};
}

angular.module('prism-ui.components').component('weekdaySelector', {
	templateUrl: 'components/visual/weekdaySelector/weekday-selector-component-template.html',
	controller: WeekdaySelectorController,
	bindings: {
		enabledDays: '<',
		updated: '&',
	}
});
